import type { EventProperties } from '@segment/analytics-next'

import { analytics } from 'analytics/analytics.utils'
import {
  getCurrentCountry,
  getCurrentWarehouse,
  getUser
} from 'client/utilities.client-helper'
import type {
  AutomaticUpdateStatusEventParams,
  PrintSuccessEventParams,
  SelectOrderEventParams,
  UpdateOrderStatusEventParams
} from './assembly-analytics.types'

const EVENT = 'Assembly'
const VERSION = 'v1.1.0'

const errorHandler = (e: any) => {
  console.error('Error calling analytic event', e)
}

const addCommonProps = (props: EventProperties) => {
  const warehouse = getCurrentWarehouse()
  const country = getCurrentCountry()
  return {
    ...props,
    warehouse,
    country,
    version: VERSION,
    user: getUser().username
  }
}

const trackEvent = (eventName: string, props: EventProperties) => {
  const data = addCommonProps(props)
  console.info(eventName, data)
  analytics.track(`${EVENT} - ${eventName}`, data).catch(errorHandler)
}

export const selectOrder = (e: SelectOrderEventParams) => {
  trackEvent('Select Order', e)
}

export const automaticUpdateStatus = (e: AutomaticUpdateStatusEventParams) => {
  trackEvent('Automatic Update Status', e)
}

export const updateOrderStatus = (e: UpdateOrderStatusEventParams) => {
  trackEvent('Update Order Status', e)
}

export const printSuccess = (e: PrintSuccessEventParams) => {
  trackEvent('Print Success', e)
}
